import { useMutation } from "@tanstack/react-query";
import { useAppMutation, useAppQuery } from "../customReactQuery";
import { get, post } from "../../api/client";
import { AcademicPayloadInterface } from "../../Constants/Interfaces/payloadInterface/AcademicPricesPayload.interface";
import queryClient from "../../config/queryClient";

export const ACDEMIC_PRICES_KEY = {
  ACADEMIC_PRICES_LIST: "ACADEMIC_PRICES_LIST",
  ACADEMIC_PRICES_CLASS: "ACADEMIC_PRICES_CLASS",
};

export const useAddAcademicPrices = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: unknown) => unknown;
}) =>
  useAppMutation<unknown, unknown, AcademicPayloadInterface, unknown>(
    (data: AcademicPayloadInterface) =>
      post({
        url: "api/v1/academic-prices/create",
        body: data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [ACDEMIC_PRICES_KEY.ACADEMIC_PRICES_LIST],
        });
      },
      onError,
    }
  );

export const useGetAllAcademicPrices = () =>
  useAppQuery([ACDEMIC_PRICES_KEY.ACADEMIC_PRICES_LIST], () =>
    get({
      url: "api/v1/academic-prices",
    })
  );

export const useGetAcademicPricesForClass = ({
  classId,
  onSuccess,
}: {
  classId: number;
  onSuccess: (data: any) => unknown;
}) => {
  return useAppQuery(
    [classId, ACDEMIC_PRICES_KEY.ACADEMIC_PRICES_CLASS],
    () => {
      return get({
        url: `api/v1/academic-prices/class/${classId}`,
      });
    },
    {
      enabled: !!classId,
      onSuccess,
    }
  );
};
